import type { ReactNode } from "react";
import { Alert, Banner, Toast, ToastRegion, Skeleton, ProgressBar, Spinner, ResultPanel, PermissionState, MaintenanceState, OfflineState, RetryPanel, EmptyState, LoadingState, BlockedState, StatePanel, ExceptionPanel, RuntimeDiagnosticBanner, FieldErrorList, CallbackExceptionPanel, FormRuntimeGuard, DataBoundary, WorkspaceErrorBoundary, ErrorBoundary } from "@swot/base-components";

export { Alert, Banner, Toast, ToastRegion, Skeleton, ProgressBar, Spinner, ResultPanel, PermissionState, MaintenanceState, OfflineState, RetryPanel, EmptyState, LoadingState, BlockedState, StatePanel, ExceptionPanel, RuntimeDiagnosticBanner, FieldErrorList, CallbackExceptionPanel, FormRuntimeGuard, DataBoundary, WorkspaceErrorBoundary, ErrorBoundary } from "@swot/base-components";
export * from "./SwotAlert.js";
export * from "./SwotErrorBanner.js";
export * from "./SwotInlineError.js";
export * from "./SwotFieldError.js";
export * from "./SwotBlockingDialog.js";
export * from "./SwotPermissionDenied.js";
export * from "./SwotMissingEntity.js";
export * from "./SwotConflictState.js";
export * from "./SwotRetryPanel.js";
export * from "./SwotSupportDetails.js";

export function SwotPageSkeleton({ label = "Loading page", rows = 5 }: { label?: string | undefined; rows?: number | undefined }) {
  return (
    <LoadingState title={label} message="Preparing the requested workspace.">
      <Skeleton rows={rows} />
    </LoadingState>
  );
}

export function SwotSpinner({ label = "Loading" }: { label?: string | undefined }) {
  return <Spinner label={label} />;
}

export function SwotErrorAlert({ title, children }: { title: string; children?: ReactNode | undefined }) {
  return <Alert title={title} tone="error">{children}</Alert>;
}

export function SwotWarningAlert({ title, children }: { title: string; children?: ReactNode | undefined }) {
  return <Alert title={title} tone="warning">{children}</Alert>;
}

export const SwotToastRegion = ToastRegion;
export const SwotPermissionBlockedPanel = BlockedState;
export const SwotAccessDeniedShell = BlockedState;
export const SwotPwaUpdateBanner = Banner;
